import React__default, { useState, useEffect, useCallback } from 'react';
import { H2, Box } from '@vp/swan';
import { ProductOption } from '../product-option/product-option.mjs';
import '../../../../../../lodash.clonedeep/index.mjs';
import '../product-option/context/product-option-context.mjs';
import '../product-option/context/validators/description-validator.mjs';
import '../product-options-translations/product-option-translations.mjs';

const ProductOptionsSection = ({ tenant, sectionHeading, productOptions, currency, locale, fractionDigits, skin, priceDisplayMode = "differential-unit", showIncompatibleChoices = false, hideImages = false, hideDescriptions = false, debug = false, showFormErrors = false, uiDensityQuantityUpdate = false, onChangeSelections, onValidation, }) => {
    const [isValid, setIsValid] = useState(() => productOptions.every((option) => {
        return !option.isRequired || (option.isRequired && !!option.selectedKey);
    }));
    useEffect(() => {
        // calculate all options and if they are valid
        if (onValidation)
            onValidation({ isValid });
    }, [isValid]);
    const handleOptionChanged = useCallback((event) => {
        const handledSelections = productOptions.reduce((result, productOption) => {
            if (productOption.selectedKey) {
                result[productOption.key] = productOption.selectedKey;
            }
            return result;
        }, {});
        const clonedSelections = { ...handledSelections };
        const { optionKey, choiceKey } = event;
        if (optionKey && choiceKey) {
            clonedSelections[optionKey] = choiceKey;
        }
        setIsValid(productOptions.every((option) => {
            return !option.isRequired || (option.isRequired && !!clonedSelections[option.key]);
        }));
        if (onChangeSelections) {
            onChangeSelections(clonedSelections);
        }
    }, [productOptions, onChangeSelections]);
    return (React__default.createElement("section", null,
        sectionHeading && React__default.createElement(H2, null, sectionHeading),
        productOptions.map((option, index) => (React__default.createElement(Box, { key: option.key, mb: index < productOptions.length - 1 ? 5 : undefined },
            React__default.createElement(ProductOption, { showIncompatibleChoices: showIncompatibleChoices, key: option.key, productOption: option, tenant: tenant, currency: currency, locale: locale, skin: skin, priceDisplayMode: priceDisplayMode, hideImages: hideImages, hideDescriptions: hideDescriptions, fractionDigits: fractionDigits, showFormErrors: showFormErrors, onChanged: handleOptionChanged, debug: debug, uiDensityQuantityUpdate: uiDensityQuantityUpdate }))))));
};

export { ProductOptionsSection };
//# sourceMappingURL=product-options-section.mjs.map
